import { render, staticRenderFns } from "./StrokeAttrsItem.vue?vue&type=template&id=bc51580a&"
import script from "./StrokeAttrsItem.vue?vue&type=script&lang=js&"
export * from "./StrokeAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/items/StrokeAttrsItem.vue"
export default component.exports